module.exports = __webpack_public_path__ + "img/mais.bad48d4e.svg";